import React from 'react'
import { makeStyles } from 'tss-react/mui';
import { Theme, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import styled from 'styled-components';
import { colors } from '../.,/../../../theme';
import { toBool } from '../useUserProfileReducer';

const useStyles = makeStyles()((theme: Theme) =>
  ({
    boxTitle: {
      color: colors.white,
      fontWeight: 600,
      marginTop: '10px',
      fontSize: '12pt',
    },

    boxSubTitle: {
      color: colors.white,
      fontWeight: 400,
      fontStyle: 'italic',
      fontSize: '10pt',
    },

    hrLine: {
      marginTop: '20px',
      color: colors.white,
      backgroundColor: colors.white,
      height: 2,
    },

    checkBox: {
      '& svg': {
        fontSize: '1.75em',
      },
    }
  }));

export const UserPermissionsForm = props => {
  const { user, togglePermission, setEnabledAdmin, enableAdmin } = props;
  const { classes } = useStyles(props, {
    props: props
  });

  const BoxLabel = props => {
    return (
      <span>
        <span className={classes.boxTitle}>{props.title}</span>
        <br />
        <span className={classes.boxSubTitle}>{props.subtitle}</span>
        <br />
      </span>
    );
  };

  return (
    <PermissionsWrapper>
      <hr className={classes.hrLine} />
      <Typography variant="h4">Edit User Permissions</Typography>
      <Typography variant="subtitle1">
        Change the users account status and their ability to download reports or upload files.
      </Typography>
      <Checkboxes>
        <CheckboxGroup>
          <Checkbox
            onChange={() => togglePermission('accountEnabled')}
            checked={!user?.accountEnabled}
            className={classes.checkBox}
          />
          <BoxLabel
            title="Disable the Account"
            subtitle="(Clicking this box will disable the user)"
          />
        </CheckboxGroup>
        <CheckboxGroup>
          <Checkbox
            onChange={() => setEnabledAdmin(!enableAdmin)}
            checked={enableAdmin}
            className={classes.checkBox}
          />
          <BoxLabel
            title="CECL Admin"
            subtitle="(Clicking this box will make the user an CECL Administrator)"
          />
        </CheckboxGroup>
      </Checkboxes>
    </PermissionsWrapper>
  );
};

const PermissionsWrapper = styled.div`
  margin-top: 1em;
  h4 {
    font-size: 2.75em;
    font-weight: bold;
    margin-top: 2em;
  }
`;

const Checkboxes = styled.div`
  margin-top: 2em;
`;

const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1em;
`;
